import { render, staticRenderFns } from "./SetupProcessType.vue?vue&type=template&id=ce4bd078&scoped=true&"
import script from "./SetupProcessType.vue?vue&type=script&lang=js&"
export * from "./SetupProcessType.vue?vue&type=script&lang=js&"
import style0 from "./SetupProcessType.vue?vue&type=style&index=0&id=ce4bd078&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce4bd078",
  null
  
)

export default component.exports